import { render, staticRenderFns } from "./SuggestAnalysisSampleJarCard.vue?vue&type=template&id=a33ec6de&scoped=true"
import script from "./SuggestAnalysisSampleJarCard.vue?vue&type=script&lang=js"
export * from "./SuggestAnalysisSampleJarCard.vue?vue&type=script&lang=js"
import style0 from "./SuggestAnalysisSampleJarCard.vue?vue&type=style&index=0&id=a33ec6de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33ec6de",
  null
  
)

export default component.exports